<template>
  <div class="watermark-container" ref="container">
    <slot></slot>
  </div>
</template>

<script>
function useWatermarkBg(text, fontSize, gap) {
  // 创建一个 canvas
  const canvas = document.createElement("canvas");
  const devicePixelRatio = window.devicePixelRatio || 1;
  // 设置字体大小
  const fontSizePx = fontSize * devicePixelRatio;
  const font = fontSizePx + "px serif";
  const ctx = canvas.getContext("2d");
  // 获取文字宽度
  ctx.font = font;
  const { width } = ctx.measureText(text);
  const canvasSize = Math.max(100, width) + gap * devicePixelRatio;
  canvas.width = canvasSize;
  canvas.height = canvasSize;
  ctx.translate(canvas.width / 2, canvas.height / 2);
  // 旋转 45 度让文字变倾斜
  ctx.rotate((Math.PI / 180) * - 30);
  ctx.fillStyle = "rgba(0, 0, 0, 0.3)";
  ctx.font = font;
  ctx.textAlign = "center";
  ctx.textBaseline = "middle";
  // 将文字画出来
  ctx.fillText(text, 0, 0);
  return {
    base64: canvas.toDataURL(),
    size: canvasSize,
    styleSize: canvasSize / devicePixelRatio,
  };
}

export default {
  name: 'Watermark',
  props: {
    text: {
      type: String,
      default: 'Watermark'
    },
    fontSize: {
      type: Number,
      default: 16
    },
    gap: {
      type: Number,
      default: 20
    }
  },
  data() {
    return {
      observer: null,
      watermarkElement: null
    }
  },
  watch: {
    '$route.path': {
      handler(val) {
        if (val !== '/') {
          this.$nextTick(() => {
            this.createWatermark();
            this.setupObserver();
          });
        } else {
          this.destroyObserver();
          setTimeout(() => {
            this.$refs.container && this.$refs.container.removeChild(this.watermarkElement);
          }, 16);
        }
      }
    }
  },
  beforeDestroy() {
    this.destroyObserver();
  },
  methods: {
    createWatermark() {
      const {base64, styleSize} = useWatermarkBg(this.text, this.fontSize, this.gap);

      if (this.watermarkElement) {
        this.watermarkElement.remove();
      }

      this.watermarkElement = document.createElement('div');
      this.watermarkElement.className = 'watermark';
      Object.assign(this.watermarkElement.style, {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
        backgroundImage: `url(${base64})`,
        backgroundRepeat: 'repeat',
        backgroundSize: `${styleSize}px ${styleSize}px`,
        zIndex: 1999
      });

      this.$refs.container.appendChild(this.watermarkElement);
    },
    setupObserver() {
      this.observer = new MutationObserver(this.handleDomChange);
      this.observer.observe(this.$refs.container, {
        attributes: true,
        childList: true,
        subtree: true,
        characterData: true
      });
    },
    destroyObserver() {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
    },
    handleDomChange(mutations) {
      let needRecreateMark = false;

      for (let mutation of mutations) {
        if (mutation.type === 'childList') {
          const removedNodes = Array.from(mutation.removedNodes);
          if (removedNodes.includes(this.watermarkElement)) {
            needRecreateMark = true;
            break;
          }
        } else if (mutation.type === 'attributes' && mutation.target === this.watermarkElement) {
          needRecreateMark = true;
          break;
        }
      }

      if (needRecreateMark) {
        this.$nextTick(() => {
          this.createWatermark();
        });
      }
    }
  }
}
</script>

<style scoped>
.watermark-container {
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/waterMark.vue